<template>
  <b-modal
    id="my-modal"
    ref="myModal"
    :title="title"
    @hide="resetForm"
    hide-footer
  >
    <div v-if="contentLoaded">
      <div class="row mb-4">
        <div class="col-md-12">
          <label for="change_reason">Motivo da alteração *</label>
          <div class="input-group">
            <input
              type="text"
              ref="change_reason"
              class="form-control"
              maxlength="255"
              v-model="change_reason"
              id="change_reason"
              @keydown.enter="handleSubmit"
              required
            />
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-md-6">
          <b-button 
            variant="primary" 
            @click="handleSubmit"
            :disabled="!change_reason || change_reason.trim() === ''"
          >
            Salvar
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { returnMessageMixin } from '@/mixins/returnMessageMixin';
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'PendingInvoiceStatusChange',
  mixins: [returnMessageMixin],
  data() {
    return {
      customer: null,
      title: null,
      contentLoaded: false,
      change_reason: null,
    };
  },
  methods: {
    openModal() {
      this.$bvModal.show('my-modal');
    },
    closeModal() {
      this.$emit('updateList');
      this.$bvModal.hide('my-modal');
    },
    resetForm() {
      this.contentLoaded = false;
    },
    setContent(customer, title, pendingInvoiceId) {
      this.customer = customer;
      this.title = title;
      this.pendingInvoiceId = pendingInvoiceId;
      this.contentLoaded = true;
    },
    handleSubmit() {
      const url = `${baseApiUrl}/v1/invoice/pending/block-customer`;
      axios
        .post(url, {
          customer_id: this.customer.id,
          block: this.customer.status == 1,
          change_reason: this.change_reason,
          pending_invoice_id: this.pendingInvoiceId,
        })
        .then((response) => {
          this.logMessage(response);
          this.change_reason = null;
          this.closeModal();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
  },
};
</script>